module.exports = __webpack_public_path__ + "img/bg_app.9127225d.svg";